import React from 'react';
const Logs = (props) => (
    <svg
        width="23px"
        height="22px"
        viewBox="0 0 12 12"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        {...props}
    >
        <title>{"Combined Shape Copy 9"}</title>
        <desc>{"Created with Sketch."}</desc>
        <g
            id="Changes,-Tests,-Widgets"
            stroke="none"
            strokeWidth={1}
            fillRule="evenodd"
        >
            <g id="Tests-History" transform="translate(-1156.000000, -1289.000000)">
                <path
                    d="M1168,1289 L1156,1289 L1156,1301 L1168,1301 L1168,1289 Z M1165,1292 L1159,1292 L1159,1293 L1165,1293 L1165,1292 Z M1159,1294 L1165,1294 L1165,1295 L1159,1295 L1159,1294 Z M1165,1296 L1159,1296 L1159,1297 L1165,1297 L1165,1296 Z"
                    id="Combined-Shape-Copy-9"
                    fill="#707070"
                />
            </g>
        </g>
    </svg>
);
export default Logs;
